import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable()
export class ImpersonationInterceptor implements HttpInterceptor {
  constructor(private readonly auth: AuthService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const impersonatedUser = this.auth.impersonatedUser();
    if (impersonatedUser && !req.url.includes('scd.suites')) {
      req = req.clone({
        setHeaders: {
          'X-Impersonate': impersonatedUser + '',
        },
      });
    }
    return next.handle(req);
  }
}
